import { render, staticRenderFns } from "./inventoryPage.vue?vue&type=template&id=add7b3aa&"
import script from "./inventoryPage.vue?vue&type=script&lang=ts&"
export * from "./inventoryPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports